<template>
    <div id="work_space">
        <div class="h-screen bg-img-work-space no-gutter">
            <div class="vx-row" id="work-space">
                <div class="vx-col w-full">
                    <div class="vx-row" v-if="checkSettingWorkspace">
                        <div class="vx-col w-full">
                            <div class="float-right p-4">
                                <vx-tooltip class="position-icon" text="Cài đặt" position="left" color="primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px"
                                         viewBox="0 0 24 24"
                                         fill="none" class="cursor-pointer" @click="$router.push('/user/settings')">
                                        <path
                                            d="M20.1 9.2214C18.29 9.2214 17.55 7.9414 18.45 6.3714C18.97 5.4614 18.66 4.3014 17.75 3.7814L16.02 2.7914C15.23 2.3214 14.21 2.6014 13.74 3.3914L13.63 3.5814C12.73 5.1514 11.25 5.1514 10.34 3.5814L10.23 3.3914C9.78 2.6014 8.76 2.3214 7.97 2.7914L6.24 3.7814C5.33 4.3014 5.02 5.4714 5.54 6.3814C6.45 7.9414 5.71 9.2214 3.9 9.2214C2.86 9.2214 2 10.0714 2 11.1214V12.8814C2 13.9214 2.85 14.7814 3.9 14.7814C5.71 14.7814 6.45 16.0614 5.54 17.6314C5.02 18.5414 5.33 19.7014 6.24 20.2214L7.97 21.2114C8.76 21.6814 9.78 21.4014 10.25 20.6114L10.36 20.4214C11.26 18.8514 12.74 18.8514 13.65 20.4214L13.76 20.6114C14.23 21.4014 15.25 21.6814 16.04 21.2114L17.77 20.2214C18.68 19.7014 18.99 18.5314 18.47 17.6314C17.56 16.0614 18.3 14.7814 20.11 14.7814C21.15 14.7814 22.01 13.9314 22.01 12.8814V11.1214C22 10.0814 21.15 9.2214 20.1 9.2214ZM12 15.2514C10.21 15.2514 8.75 13.7914 8.75 12.0014C8.75 10.2114 10.21 8.7514 12 8.7514C13.79 8.7514 15.25 10.2114 15.25 12.0014C15.25 13.7914 13.79 15.2514 12 15.2514Z"
                                            fill="rgba(var(--vs-primary),1)"/>
                                    </svg>
                                </vx-tooltip>

                            </div>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col w-full mb-8 flex flex-wrap justify-center">
                            <div class="sm:w-2/3 lg:w-3/4 xl:w-2/3 m-4 lg:py-32 py-16">
                                <div class="flex flex-wrap gap-x-32 gap-y-16">
                                    <div class="work_space_app" v-for="(item, ind) in workspaceData" :key="ind">
                                        <div class="backround_icon_app"
                                             @click="selectWorkSpace(item)">
                                            <img
                                                :src="item.fileManagers.length > 0 ? item.fileManagers[0].url : null"
                                                alt="" class="icon_app">
                                        </div>
                                        <span class="font-medium text-lg">{{
                                                item.nameIconApp
                                            }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WorkSpace",
    data() {
        return {
            workspaceData: [],
            token: localStorage.getItem('access_token'),
        }
    },

    async created() {
        if (this.token) {
            await this.getWorkspaceOrg();
        } else {
            await this.getAllWorkspace();
        }
    },

    computed: {
        checkSettingWorkspace() {
            if (this.token) {
                let userInfo = JSON.parse(localStorage.getItem('userInfo'));
                if (userInfo.userRole == 'user') return false;
                return true;
            }
            return false;
        },
    },

    methods: {
        selectWorkSpace(item) {
            if (!this.token) return this.$router.push('/pages/login')
            localStorage.setItem("work_space", item.urlApp.includes('hrm') ? 'hrm' : 'crm');
            localStorage.setItem("isChat", item.urlApp.includes('message'));
            let space = localStorage.getItem('work_space');
            let isChat = JSON.parse(localStorage.getItem('isChat'));
            if (space === 'hrm' && !isChat) return this.$router.push(item.urlApp).catch(() => {});
            if (space === 'crm' && !isChat) return this.$router.push(item.urlApp).catch(() => {});
            if (isChat) return this.$router.push(item.urlApp).catch(() => {});
        },

        getWorkspaceOrg() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get('/setting/organization-workspace/find-by-organization-id').then(res => {
                    this.workspaceData = res.data.map(el => el.settingProjectWorkspace);
                    localStorage.setItem('work_space_list', JSON.stringify(this.workspaceData));
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getAllWorkspace() {
            return new Promise((resolve, reject) => {
                let payload = {
                    pageNumber: 0,
                    pageSize: 100,
                }

                this.$vs.loading();
                this.$crm.post('/setting/find-by-condition', payload).then(res => {
                    this.workspaceData = res.data.content;
                    resolve(res)
                    this.$vs.loading.close();
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
.bg-img-work-space {
    background-image: url("../../assets/images/pages/background-light.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

#work_space {
    .work_space_app {
        text-align: -webkit-center;
        cursor: pointer;

        .backround_icon_app {
            display: flex;
            padding: 10px;
            border-radius: 6px;
            background: #FFF;
            width: 70px;
            height: 70px;
            margin-bottom: 0.5rem;

            &:hover {
                transition: all 0.2s ease-out;
                box-shadow: rgba(0, 0, 0, 0.25) 0 14px 28px, rgba(0, 0, 0, 0.22) 0 10px 10px;
                top: -10px;
            }

            .icon_app {
                width: 50px;
                height: 50px;
            }
        }
    }
}
</style>

